<template class="text-center" v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" class="mb-3" ></spinner>

    <div class="page mb-4" v-else-if="loaded" >
        
        <div class="col-12 p-0 " >
            <div class="pt-0 pb-2 " >
                <h1 class="h3 font-900 d-inline-block w-auto" > 
                    This Month
                </h1>
                <span class="float-right font-size-14" >
                    Refresh: <a @click="initiate" class="ml-1 font-size-14"  > <font-awesome-icon icon="sync" /> </a>
                </span>
            </div>
        </div>
        
        <div class="row m-0 flex-wrap-scroll" >
            
            <div class="col-5 col-md p-1" >
                <div class="border-radius pt-3 pb-3 pl-4 pr-4 gradient-blue Text-color--white" >
                    <h1 class="h2" v-if="!data.active" > - </h1>
                    <h1 class="h2" v-else-if="data.active" > 
                        {{ data.active }} 
                    </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--white" > CUSTOMERS </p>
                    <div class="mt-2" >
                        <!-- PROGRESS BAR -->
                        <b-progress :max="( data.customers.reduce((a, b) => +a + +b.count, 0) )" class="customers-progress-bar" height="20" >

                            <b-progress-bar v-for="(item, index) in data.customers" :key="index" :style="'background:'+item.color" :value="item.count" :id="`tooltip--customers-progress-`+index"  ></b-progress-bar>

                            <b-tooltip :target="`tooltip--customers-progress-`+index" placement="bottom" triggers="hover" custom-class="tooltip-narrow" v-for="(item, index) in data.customers" :key="item.leadID" >
                                {{ item.name }} customers - {{ item.count }} 
                            </b-tooltip>

                        </b-progress>
                        <!-- PROGRESS BAR -->
                    </div>
                </div>
            </div>
            
            <div class="col-5 col-md p-1" >
                <div class="border-radius pt-3 pb-3 pl-4 pr-4  h-100 gradient-pink Text-color--white" >
                    <h1 class="h2 " v-if="!data.purchases" > - </h1>
                    <h1 class="h2 " v-else-if="data.purchases" > 
                        {{ data.purchases }}  
                    </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--white" > PURCHASES </p>
                    <div class="mt-2 " >
                        <!-- PROGRESS BAR -->
                        <b-progress :max="( data.purchases + data.purchases_failed )" class="customers-progress-bar" height="20" >

                            <b-progress-bar :style="'background: green'" :value="data.purchases" :id="`tooltip--success-purchases-progress`"  ></b-progress-bar>
                            <b-tooltip :target="`tooltip--success-purchases-progress`" placement="bottom" triggers="hover" custom-class="tooltip-narrow"  >
                                {{ data.purchases }} successful purchases
                            </b-tooltip>
                            
                            <b-progress-bar :style="'background: red'" :value="data.purchases_failed" :id="`tooltip--failed-purchases-progress`"  ></b-progress-bar>
                            <b-tooltip :target="`tooltip--failed-purchases-progress`" placement="bottom" triggers="hover" custom-class="tooltip-narrow" >
                                {{ data.purchases_failed }} purchases failed or refunded
                            </b-tooltip>

                        </b-progress>
                        <!-- PROGRESS BAR -->
                    </div>
                </div>
            </div>
            
            <div class="col-5 col-md p-1" >
                <div class="border-radius pt-3 pb-3 pl-4 pr-4 h-100 gradient-purple Text-color--white" >
                    <h1 class="h2" v-if="!data.revenue" > - </h1>
                    <h1 class="h2" v-else-if="data.revenue" > 
                        {{ Numberformatter( data.revenue, 'number' ) }} 
                    </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--white" > REVENUE </p>
                    <div class="mt-2" >
                        <!-- PROGRESS BAR -->
                        <b-progress :max="( data.revenue + data.revenue_failed )" class="customers-progress-bar" height="20" >

                            <b-progress-bar :style="'background: green'" :value="data.revenue" :id="`tooltip--success-revenue-progress`"  ></b-progress-bar>
                            <b-tooltip :target="`tooltip--success-revenue-progress`" placement="bottom" triggers="hover" custom-class="tooltip-narrow" >
                                {{ Numberformatter( data.revenue, 'number' ) }} revenue from successful purchases
                            </b-tooltip>
                            
                            <b-progress-bar :style="'background: red'" :value="data.revenue_failed" :id="`tooltip--failed-revenue-progress`"  ></b-progress-bar>
                            <b-tooltip :target="`tooltip--failed-revenue-progress`" placement="bottom" triggers="hover" custom-class="tooltip-narrow" >
                                {{ Numberformatter( data.revenue_failed, 'number' ) }} revenue from failed or refunded purchases
                            </b-tooltip>

                        </b-progress>
                        <!-- PROGRESS BAR -->
                    </div>
                </div>
            </div>
            
            <div class="col-5 col-md p-1" >
                <div class="border-radius pt-3 pb-3 pl-4 pr-4 gradient-orange h-100 Text-color--white" >
                    <h1 class="h2 mt-3" v-if="!data.avg_purchase_value" > - </h1>
                    <h1 class="h2 mt-3" v-else-if="data.avg_purchase_value" > 
                        {{ Numberformatter( data.avg_purchase_value, 'number' ) }} 
                    </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--white" > AOV </p>
                    <div class="mt-2" >
                        
                    </div>
                </div>
            </div>
                        
            <div class="col-5 col-md p-1" >
                <div class="border-radius pt-3 pb-3 pl-4 pr-4 gradient-green h-100 Text-color--white" >
                    <h1 class="h2 mt-3" v-if="!data.avg_revenue_per_customer" > - </h1>
                    <h1 class="h2 mt-3" v-else-if="data.avg_revenue_per_customer" > 
                        {{ Numberformatter( data.avg_revenue_per_customer, 'number' ) }}
                    </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--white" > ARPU </p>
                    <div class="mt-2" >
                        
                    </div>
                </div>
            </div>
                        
            <div class="col-5 col-md p-1" >
                <div class="border-radius pt-3 pb-3 pl-4 pr-4 gradient-yellow h-100 Text-color--white" >
                    <h1 class="h2 mt-3" v-if="!data.ltv" > - </h1>
                    <h1 class="h2 mt-3" v-else-if="data.ltv" > 
                        {{ Numberformatter( data.ltv, 'number' ) }}
                    </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--white" > LTV </p>
                    <div class="mt-2" >
                        
                    </div>
                </div>
            </div>
            
        </div>
        
    </div>

</template>

<script>
import {_} from 'vue-underscore';
import axios from 'axios'
    
import pieChart from '@/components/charts/pieChart.js'   
import moment from 'moment'    

import helper from '@/helpers/helpers.js';

export default {
    name: 'overview-cards',
    props:{
        contentType: { type: [ String ], default: 'full' }, /* full -> full page; overview -> overview source */ 
        parentPeriod: { type: [ Array ], default: null }, 
        passedAPPKEY:{ type : [String, Boolean], default: false },
    },
    components:{
        pieChart
    },
    data: function(){
        return {
            loaded: false,
            error: false,
            startDate: null,
            endDate: null,
            formatDate: 'D MMM YYYY',
            period: [ "", "" ],
            
            data: {},
            ltv:{
                
            }
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        //this.$watch()
    },
    mounted: function () {
        
        //console.log( this.startDate + " " + this.endDate )
        
        this.initiate()
        
        
    },
    beforeDestroy() {
    },
    methods: {
        
        initiate(){
            
            this.loaded = false
            
            let start = this.$moment(Date.now()).startOf('month').format('D MMM YYYY');
            //let end = this.$moment(Date.now()).subtract(1,'month').endOf('month').format('D MMM YYYY');
            let end = this.$moment(Date.now()).endOf('month').format('D MMM YYYY');

            if( this.parentPeriod != null ){
                start = this.parentPeriod[0]
                end = this.parentPeriod[1]
            }
            
            this.period = [ start, end ];
            
            this.get_customers(  )
            
        },
        
        get_customers(){
            
            this.chartLoaded = false
            
           let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8' }
            
            this.startDate = moment(this.period[0]).unix()
            this.endDate = moment(this.period[1]).endOf('day').unix()
            
            let timezone = helper.getAccountTimezone()            
            let start = moment.tz(this.period[0], 'D MMM YYYY', timezone ).startOf('day').tz( 'UTC' ).unix()
            let end = moment.tz(this.period[1], 'D MMM YYYY', timezone ).endOf('day').tz( 'UTC' ).unix()

            let previous = moment.unix(start).subtract(1, 'month').startOf('month').unix();
            let previous_end = moment.unix(end).subtract(1, 'month').startOf('month').unix();
            if( end > Math.round(+new Date()/1000) ){
                end = Math.round(+new Date()/1000)
                previous = moment.unix(start).subtract(1, 'month').unix();
                previous_end = moment.unix(end).subtract(1, 'month').unix();
            }
            
            axios({ 
                method: 'POST', 
                //url: process.env.ROOT_API+'/analyze/stats/customers', 
                //url: 'https://192.168.64.4/theatlass.com/sql/api-v2/analyze/stats.php?query=customers',
                url: 'https://sql.theatlass.com/api-v2/analyze/stats.php?query=customers',
                headers: headers, 
                data: { 
                    "APPKEY": ( ( this.passedAPPKEY != false ) ? this.passedAPPKEY : helper.getLoggedInOrganization( this.$store.getters.isAdmin ) ),
                    "startDate":  start,
                    "endDate":  end,
                    "previous":  previous,
                    "previous_end":  previous_end,
                } 
            })
            .then(resp => {
                //console.log(resp)
                if( resp.status == 200 ){
                    let data = resp.data.data
                    
                    //console.log(data)
                    this.data = data
                }
                
            })
            .then(function(sales){
                
                this.loaded = true
                //this.get_customer_lifespan()
                
            }.bind(this))
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error getting customers. Please reach out to us!'
                })
                
            }); //end axios 
            
        },
        
        get_customer_lifespan(){
            
            this.chartLoaded = false
            
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8' }

            axios({ 
                method: 'POST', 
                url: process.env.ROOT_API+'/analyze/stats/lifespan', 
                headers: headers, 
                data: { 
                    "APPKEY": ( ( this.passedAPPKEY != false ) ? this.passedAPPKEY : helper.getLoggedInOrganization( this.$store.getters.isAdmin ) ),
                } 
            })
            .then(resp => {
                //console.log(resp)
                if( resp.status == 200 ){
                    let data = resp.data.body
                    
                    //console.log(data)
                    this.ltv = data
                    let SUM_OF_CUSTOMER_LIFESPAN = data.SUM_OF_CUSTOMER_LIFESPAN / 31 //days to months
                    let AVG_CUSTOMER_LIFESPAN = SUM_OF_CUSTOMER_LIFESPAN / data.customers
                    this.ltv.LTV = AVG_CUSTOMER_LIFESPAN * this.data.avg_revenue_per_customer
                }
                
            })
            .then(function(sales){
                
                this.loaded = true
                
            }.bind(this))
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error getting customers. Please reach out to us!'
                })
                
            }); //end axios 
            
        },
        
        Numberformatter(value, type, html, color ) {   
            return helper.Numberformatter(value, type, html, color );
        }

    },
    computed: {
    },
    watch: {

        
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    .template-loading{
        margin-top: 50px;
        margin-bottom: 100px;
    }
    
    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;
    }
    
</style>



// WEBPACK FOOTER //
// src/components/overview-cards.vue